import React from 'react';
import { Checkbox, Row } from 'antd';
import { CheckboxValueType } from 'antd/es/checkbox/Group';

interface CustomCheckProps{
  className?: string,
  title: string,
  values: any,
  value: any,
  onChange: any,
  error: any,
}

export default function CustomCheck({
  className, title, values, onChange, error, value
}: CustomCheckProps) {
  return (
    <div className={`${className || ''} flexCol`}>
      <p>{title}</p>
      <div className="customMarginTop">
        <Checkbox.Group
          onChange={(e:CheckboxValueType[] | {[p:string]: any}) => { onChange(e); }}
          defaultValue={value}
        >
          { values.map(({ valor, descripcion }: any) => (
            <Row key={valor}>
              <Checkbox value={valor}>{descripcion}</Checkbox>
            </Row>
          )) }
        </Checkbox.Group>
      </div>
      <div>
        {(error && (
          <p className="errors">{error.message}</p>
        ))
        }
      </div>
    </div>
  );
}
